<template xmlns:v-on="http://www.w3.org/1999/xhtml">
<div class="form-content pb-2">

  <h3 class="title">Seferler</h3>
  <p class="font-size-14" v-if="sailList !== null">{{ sailList.length }} sefer listeleniyor</p>

  <base-select-input
      v-model="filterSailActive"
      :optionList="[{name:'Satışa Açık',id:'open'},{name:'Satışa Kapalı',id:'closed'},{name:'Hepsi',id:'all'}]"
      :rules="'required'"
      :type="'text'"
      :label="'Active Filter'"
  ></base-select-input>

  <div class="table-form table-responsive">
    <table class="table">
      <thead>
      <tr>
        <th scope="col">#</th>
        <th>Adı</th>
        <th>Tarih</th>
        <th>Tur Kodu</th>
<!--        <th>Toplam Oda</th>-->
<!--        <th>Müsait Oda</th>-->
        <th>Vize Durumu</th>
        <th>Satış Durumu</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="sail in filteredSailList" :key="sail.id">
        <th scope="row"><a :href="basePath+'/sails/'+sail.id">#{{sail.id}}</a></th>
<!--        <th>{{ sail.cruise.name }}</th>-->
        <th>MV GEMINI</th>
        <th>{{ sail.sailDate | ddMMyyyy }}</th>
        <th>{{sail.seaTour.tourCode}}</th>
<!--        <th>{{sail.totalRoomCount}}</th>-->
<!--        <th>{{sail.availableRoomCount}}</th>-->
        <th>
          <span v-if="sail.seaTour.visaRequired" class="badge badge-warning py-1 px-2"
                style="color: white;">
              Vize Gerekli
          </span>
        </th>
        <th v-if="sail.saleOpen">
          <span class="badge badge-success py-1 px-2">Satışa Açık</span>
        </th>
        <th v-if="!sail.saleOpen">
          <span class="badge badge-warning py-1 px-2"
                style="background-color: #d32727;color: white;">
              Satışa Kapalı
          </span>
        </th>
        <td>
          <div class="row">
            <div class="table-content mr-2" v-on:click="deleteSail(sail)">
              <a href="javascript:void(0)" class="theme-btn theme-btn-small" data-toggle="tooltip" data-placement="top" title="" data-original-title="Edit">
                <i class="la la-trash"></i>
              </a>
            </div>
            <div class="table-content">
              <a :href="basePath+'/sails/'+sail.id" class="theme-btn theme-btn-small" data-toggle="tooltip" data-placement="top" title="" data-original-title="Edit">
                <i class="la la-edit"></i>
              </a>
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</div>

</template>

<script>
import messagePopupManager from "../../util/messagePopupManager";
import helper from "../../store/helper/cruiseStoreHelper";
import BaseSelectInput from "../base/BaseSelectInput";

export default {
  name: "SailList",
  components: {BaseSelectInput},
  data:function (){
    return {
      filterSailActive: "all"
    };
  },
  props : {
    sailList: null,
  },
  computed:{
    filteredSailList:{
      get(){
        if(!this.sailList){
          return [];
        }

        let sailList = this.sailList;

        sailList = sailList.filter(sail =>{
          switch (this.filterSailActive){
            case "open":
              return sail.saleOpen;
            case "closed":
              return !sail.saleOpen;
            case "all":
              return true;
            default:
              throw "wrong filter";
          }
        })
        return sailList;
      }
    },
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    }
  },
  methods:{
    deleteSail(sail){
      messagePopupManager.showDeleteQuestion(() => {
        this.$store.dispatch("deleteSail", sail)
        .then(response => {
          messagePopupManager.showSuccess()
        })
        .catch(error => {
          helper.checkDeleteResponseCodeAndShowPopup(error.code);
        });
      })
    },
    showBatchEditModal(){
      $("#sailBatchUpdateModal").modal("show");
    }
  },
  mounted() {
    //TODO: What is this dispatches ?
    let cruise = this.$store.getters.getCruise;
    if(cruise !== null)     this.$store.dispatch("loadCruiseRoomList", cruise.id);
    this.$store.dispatch("loadRoomList")
  },
}
</script>

<style scoped>

</style>